/** @format */

import * as React from "react";
import {
  Flex,
  Text,
  useMediaQuery,
  Stack,
  Button,
  Center,
  Link
} from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import colors from "@src/style/colors";
import style from "./style.module.css";
import theme from "@src/style/theme";

export const Into_EN: React.FC = () => {
  const [isXS, isSmall] = useMediaQuery([
    `(max-width: ${theme.breakpoints.sm})`,
    `(max-width: ${theme.breakpoints.md})`
  ]);

  return (
    <Flex
      position={"static"}
      width={"100%"}
      flexDirection={"row"}
      justifyContent={"center"}
      alignItems={"center"}
      bgColor={colors.white}
      paddingX={{
        base: "20px",
        sm: "20px",
        md: "65px",
        lg: "108px",
        xl: "122px"
      }}
      pt={{ base: "20px", md: "45px", lg: "45px" }}
      pb={{ base: "44px", sm: "72px", md: "56px", lg: "120px" }}
    >
      <Flex
        maxWidth={theme.breakpoints.mx}
        direction={{ base: "column-reverse", md: "row" }}
        justifyContent={"space-between"}
        alignItems={"center"}
        width={"100%"}
        backgroundColor={colors.white}
      >
        <Flex
          direction={"column"}
          justifyContent={"flex-start"}
          flexGrow={1}
          alignItems={isSmall ? "center" : "start"}
          mt={isSmall ? "40px" : "0px"}
        >
          <Stack
            fontSize={{
              base: "24px",
              sm: "32px",
              md: "35px",
              lg: "36px"
            }}
            fontWeight={"700"}
            textAlign={isSmall ? "center" : "start"}
            gap={"10px"}
          >
            <Text color={colors.black} wordBreak={"keep-all"}>
              Innovative WEB 3.0 Platform
              <br />
              for Crypto Assets
            </Text>
          </Stack>
          <Stack
            pt={{
              base: "20px",
              sm: "40px",
              md: "20px",
              lg: "50px",
              xl: "50px"
            }}
            textAlign={isSmall ? "center" : "start"}
            fontSize={{
              base: "16px",
              sm: "18px",
              md: "16px",
              lg: "24px",
              xl: "28px"
            }}
          >
            <Text fontWeight={500} color={colors.black} wordBreak={"keep-all"}>
              Sandbank offers a unique and
              <br />
              unparalleled crypto investment
              <br />
              experience like no other.
            </Text>
          </Stack>
          <Stack
            pt={{
              base: "32px",
              sm: "50px",
              md: "30px",
              lg: "80px",
              xl: "80px"
            }}
            direction={"row"}
            spacing={"16px"}
          >
            <Link href={commonInfo.appDownload.items[1].url} isExternal>
              <Button
                width={isXS ? "120px" : "165px"}
                height={isXS ? "44px" : "60px"}
                bgGradient="linear(to-tl,#01F6FF, #007BFF)"
                borderRadius={"8px"}
                style={{ transition: "opacity 0.3s" }}
                _hover={{ opacity: "0.5" }}
              >
                <Text
                  wordBreak={"keep-all"}
                  color={colors.white}
                  fontSize={{ base: "12px", sm: "16px" }}
                  fontWeight={"600"}
                >
                  Download iOS
                </Text>
              </Button>
            </Link>
            <Link href={commonInfo.appDownload.items[0].url} isExternal>
              <Button
                width={isXS ? "120px" : "165px"}
                height={isXS ? "44px" : "60px"}
                bgGradient="linear(to-tl,#01F6FF, #007BFF)"
                borderRadius={"8px"}
                style={{ transition: "opacity 0.3s" }}
                _hover={{ opacity: "0.5" }}
              >
                <Text
                  wordBreak={"keep-all"}
                  color={colors.white}
                  fontSize={{ base: "12px", sm: "16px" }}
                  fontWeight={"600"}
                >
                  Download Android
                </Text>
              </Button>
            </Link>
          </Stack>
        </Flex>
        <Center
          width={{
            base: "100%",
            sm: "400px",
            md: "400px",
            lg: "540px",
            xl: "680px"
          }}
        >
          <div className={style.image_box}>
            <video autoPlay loop muted playsInline>
              <source src={commonInfo.intro.video.intro} type="video/mp4" />
            </video>
          </div>
        </Center>
      </Flex>
    </Flex>
  );
};

export default Into_EN;
